import React, { useRef } from "react";
import { AppWrapper } from "../consteNew/styles/components";
import HeroBannner from "./components/HeroBannner";
import WhyToChooseSectionTx from "./components/WhyToChooseSectionTx";
import PlanTypesSection from "./components/PlanTypesSection";
import ComparisonSectionTx from "./components/ComparisonSectionTx";
import BannerSectionTx from "./components/BannerSectionTx";
import ImgSectionTx from "./components/ImgSectionTx";
import ReviewSection from "./components/ReviewSection";
import ChoosePlanSectionTx from "./components/ChoosePlanSectionTx";

const HomepageV2 = () => {
  const planSectionRef = useRef<HTMLDivElement>(null);

  return (
    <AppWrapper>
      <HeroBannner />
      <WhyToChooseSectionTx />      
      <ComparisonSectionTx />
      <BannerSectionTx planSectionRef={planSectionRef} />
      <ImgSectionTx />
      <ReviewSection/>
      <PlanTypesSection />
      <div ref={planSectionRef} id="plan-cards-section">
      <ChoosePlanSectionTx/>
      </div>
    </AppWrapper>
  );
};

export default HomepageV2;
